import React, { useState, useEffect } from "react";  // Importing useState and useEffect
import { Container, Row, Col, Button } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck } from "@fortawesome/free-solid-svg-icons";
import MetaManager from "../MetaManager";
import OtherServicesCarousel from "../OtherServicesCarousel";
import CallToAction from "../Home/CallToAction/CallToAction";
import BannerForm from './BannerForm';
import Faq from "./Faq";
import './Services.css';
const ThankYouCards  = () => {

  const  servicesFaqData = [
    { 
        question: "What are thank you cards, and where are they used? ", 
        answer: "Thank you cards are printed stationery items designed to express gratitude personally or professionally. They are used for weddings, corporate events, client appreciation, or personal occasions such as birthdays or anniversaries. Thank you cards help strengthen relationships by showing appreciation thoughtfully and tangibly. They can be customised with unique designs, messages, or branding to suit the occasion or recipient. Whether for a formal event or a personal gesture, thank you cards create a meaningful connection and leave a lasting impression."
    },
    { 
        question: "What are the benefits of custom-printed thank-you cards?  ", 
        answer: "Custom-printed thank-you cards allow you to create designs that reflect your personality, brand, or message. Personalisation ensures that the cards stand out and convey thoughtfulness, making your gratitude more impactful. High-quality printing enhances the appearance of the cards, adding a professional and elegant touch. Customisation options like logos, unique fonts, or special colours help align the cards with your event or brand identity. Custom thank you cards also demonstrate attention to detail, leaving recipients with a positive and memorable impression."
    },
    { 
        question: "Can Printingy handle bulk orders for thank you card printing?   ", 
        answer: "Printingy specialises in bulk thank-you card printing, providing cost-effective solutions for large-scale orders. Bulk printing is ideal for businesses, events, or individuals who require multiple cards for client appreciation, weddings, or corporate branding. Advanced printing technology ensures consistent quality across all cards, regardless of order size. We also offer quick turnaround times to ensure timely delivery for your bulk orders. Printingy’s reliable bulk printing services make it easy to share gratitude on a large scale without compromising quality."
    },
    { 
        question: "What materials are used for thank you card design & printing?", 
        answer: "Our thank you card design & printing services use premium materials such as textured cardstock, glossy paper, and recycled eco-friendly options. Textured cardstock offers a luxurious feel, perfect for formal or upscale events. The shiny paper enhances the vibrancy of colours and designs, visually striking the cards. For environmentally conscious clients, we offer recycled materials that maintain quality while supporting sustainability. Each material is carefully selected to ensure the cards are durable, visually appealing, and suited to the occasion."
    },
    { 
        question: "What industries and individuals benefit from customised thank-you card printing services? ", 
        answer: "Businesses, event planners, and individuals benefit from customised thank-you card printing services. Businesses use thank you cards to show appreciation to clients, employees, and partners, strengthening professional relationships. Event planners rely on these cards for weddings, galas, and formal gatherings to express gratitude to attendees or collaborators. Individuals use personalised thank you cards for birthdays, anniversaries, and other milestones to show appreciation. Whether for professional or personal use, thank you cards are an elegant and effective way to convey gratitude."
    },
];

    
const [pageTitle, setPageTitle] = useState('Printing for Automotive');  // Dynamic title state

useEffect(() => {
  document.title = pageTitle; // Set the document title dynamically
}, [pageTitle]); // This will run whenever the pageTitle changes


  return (
    <div>
    <MetaManager 
  title=" Custom Thank You Card Printing Services"
  description="High-quality printing of thank you cards for events, corporate use, and personal messages. Bulk card printing, custom thank you card design and personalised solutions."
  keywords="Printing of Thank You Cards,
Custom Printed Thank You Cards,
Thank You Cards Printing,
Thank You Card Design & Printing,
Customised Thank You Cards Printing

"
/>


      <header className="services-header text-center py-5  serviceheader">
        <Container>
          <Row className="align-item-cen">
            <Col lg={6}>
              <h1>Professional Printing of Thank You Cards  </h1>
              <h2 className="text-muted">Customised thank you cards for personal, corporate, and event needs     </h2>
            </Col>

            {/* Contact Form on the Right Side */}
            <Col lg={6}>
              <div className="contact-form p-4 bg-white shadow-sm rounded" style={{ maxWidth: "400px", margin: "auto" }}>
                <h3 className="text-center mb-4">Get in Touch</h3>
                <BannerForm />
              </div>
            </Col>
          </Row>
        </Container>
      </header>

      <section className="services-overview ">
        <Container>
          <p>Thank you cards are an elegant way to express gratitude, create meaningful connections, and leave a lasting impression. Printingy specialises in Printing of Thank You Cards, offering high-quality thank-you cards for personal, corporate, and event use.</p>
          <p>Our services include custom-printed thank you cards, allowing you to design cards that reflect your style, brand, or sentiment. For a polished and memorable touch, we provide thank you card design and printing tailored to your specific requirements. Our customised thank you card printing also ensures premium materials and vibrant visuals, making your message stand out.</p>
          
          
        </Container>
      </section>

      <section className="why-choose py-5">
        <Container>
          <h2 className="text-center mb-4">Why Choose Printingy</h2>

          {/* Custom Flyer Printing Experts */}
          <div className="py-4 px-3 rounded mb-4">
            <Row className="al-center">
              <Col lg={6}>
              <h2 className="small-hed">Reliable Custom Thank You Card Printing Solutions  </h2>
                <h3 className="large-hed">Elegant, high-quality thank you cards for all occasions   </h3>

                <ul className="list-unstyled">
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Expert Printing of Thank You Cards for personal and professional use.
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Bulk thank you card printing with competitive pricing.
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Fully tailored custom-printed thank you cards to match your needs.
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Professional thank you card design & printing with premium finishes.
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Durable materials and vibrant colours for a sophisticated appearance.

                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Advanced printing technology ensures sharp details and high-quality visuals.
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Quick turnaround times for bulk and customised orders.
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Trusted solutions for businesses, event organisers, and personal projects.
                  </li>
                </ul>
                <Button variant="primary" className="mt-3">
                  Contact Us
                </Button>
              </Col>

              {/* Contact Form on the Right Side */}
              <Col lg={6}>
                <img
                  src="/assets/img/thankyoucards.jpg" // Path relative to the public folder
                  alt="Professional printing of thank you cards services"
                  className="img-fluid rounded"
                />
              </Col>
            </Row>
          </div>
          <CallToAction 
       title="Connect with us Today"
        description="Your trusted Partner for Bulk Printing Solutions..!"
      />
          {/* Professional Flyer Printing with Precision */}
          <div className="shadow-sm p-4 rounded">
            <h2 className="large-hed">Premium Thank You Cards Delivered On Time  </h2>
            <h3 className="small-hed">Focus on your gratitude while we manage your thank you card printing needs</h3>
            <p>At Printingy, we combine advanced printing techniques with premium materials to deliver exceptional customised thank-you card printing solutions. Whether for corporate events, weddings, or personal messages, our thank you card printing ensures professional and heartfelt results.
            </p>
            <p>We guarantee efficiency and quality, ensuring that your thank-you cards are delivered on schedule for small or bulk orders. Partner with Printingy for elegant and reliable thank-you card printing solutions.
            </p>
          </div>
        </Container>
      </section>



      <div>
  {/* Existing Content */}
  <OtherServicesCarousel />
  {/* Other Content */}
</div>

<Faq faqData={servicesFaqData} />
   
    </div>
  );
};

export default ThankYouCards;
